
import { Component, Mixins, Prop } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component({
  components: {
    Select
  }
})
export default class WarehouseLocationCategorySelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop({ default: true })
  isActiveFilter: boolean | null;

  get options() {
    if(this.isActiveFilter)
      return barcodeSystemModule.warehouseLocationCategories.filter(x => x.isActive == this.isActiveFilter).map(x => ({ label: x.locationCategory, value: x.locationCategory })); 
    else
      return barcodeSystemModule.warehouseLocationCategories.map(x => ({ label: x.locationCategory, value: x.locationCategory })); 
  }
}
